import React, { useState } from 'react';
import { FaCheck, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useAuth } from '../../../context/AuthContext';
import { ComparePasswordDto } from '../../../interfaces/user';
import UsersService from '../../../services/UsersService';

type ValidatePasswordProps = {
    setIsValidate: React.Dispatch<React.SetStateAction<boolean>>;
    isValidate: boolean;
};

const ValidatePassword = ({ setIsValidate, isValidate }: ValidatePasswordProps) => {
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();

    // const [form, setForm] = useState({
    //     nickname: '',
    //     fecha_nacimiento: '',
    //     // email: '',
    //     parental_consent: false,
    // });


    const validateField = (value: string) => {
        let error = '';
        if (!value || value.length < 8) {
            error = 'La contraseña debe tener al menos 8 caracteres';
        } else if (!value || value.length > 25) {
            error = 'La contraseña no puede exceder los 25 caracteres';
        }
        setError(error);
        return error === '';
    };


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setPassword(value);
        validateField(value);
        if (isValidate) {
            setIsValidate(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!validateField(password)) {
            return;
        }
        setLoading(true);
        try {
            const requestData: ComparePasswordDto = {
                id_usuario: user!.id_usuario,
                password: password,
            };
            const response = await UsersService.comparePassword(requestData);
            if (response.statusCode === 200) {
                setIsValidate(true);
            } else {
                setError(response.message || 'Contraseña incorrecta');
            }
        } catch (err: any) {
            setError('Error al validar la contraseña');
            setIsValidate(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='form-group validate-password-form'>
            <label htmlFor='nickname'>Valida tu contraseña actual</label>
            <form className='validate-password-form__body' onSubmit={handleSubmit}>
                <div className='validate-password-form__field'>
                    <input
                        className='input validate-password-form__input'
                        type={showPassword ? 'text' : 'password'}
                        placeholder='Contraseña actual'
                        value={password}
                        onChange={handleChange}
                        autoComplete='current-password'
                    />
                    <button
                        type='button'
                        tabIndex={-1}
                        aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        onClick={() => setShowPassword(v => !v)}
                        className='validate-password-form__toggle'
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </div>
                <button
                    type='submit'
                    className={`btn btn-primary validate-password-form__submit${loading ? ' btn-loading' : ''}`}
                    disabled={loading || !password}
                >
                    {!loading
                        ? isValidate
                            ? <FaCheck className='validate-password-form__icon' aria-hidden='true' />
                            : 'Validar'
                        : 'Validando...'}
                </button>
            </form>
            {error && <div className='error-message validate-password-form__error'>{error}</div>}
        </div>
    );
};

export default ValidatePassword;